import { BASE } from './api.js';

/** PURGA-ESTUDIOS: un estudio que una purga podría borrar, tal como lo devuelve la vista previa. */
export interface EstudioPurgable {
  readonly slug: string;
  readonly titulo: string;
  readonly editor: string;
  readonly estado: string;
  readonly url: string | null;
  readonly urlDocumento: string | null;
  readonly hechos: number;
  readonly enPortada: boolean;
}

export interface VistaPreviaPurga {
  readonly estudios: readonly EstudioPurgable[];
  readonly parecidos: readonly EstudioPurgable[];
  readonly dominios: readonly string[];
  /** Dominios de las URL de los estudios encontrados: se proponen sin marcar. */
  readonly sugeridos: readonly string[];
}

export interface PurgaRegistrada {
  readonly id: string;
  readonly motivo: string;
  readonly solicitante: string;
  readonly ejecutadaPor: string;
  readonly ejecutadaEn: string;
  readonly estudios: number;
  readonly dominios: readonly string[];
  readonly recuentos: Readonly<Record<string, number>>;
  readonly storagePendiente: readonly string[];
}

export interface DominioBloqueado {
  readonly dominio: string;
  readonly motivo: string;
  readonly origen: 'admin' | 'autor';
  readonly bloqueadoPor: string;
  readonly bloqueadoEn: string;
}

export interface EditorConDominios {
  readonly usuarioId: string;
  readonly email: string;
  readonly puedeEnviarEstudios: boolean;
  readonly dominios: readonly string[];
}

export interface MisDominios {
  readonly dominios: readonly string[];
  readonly estudios: readonly EstudioPurgable[];
  readonly bloqueados: readonly string[];
}

export type ResultadoPurgas<T> =
  { readonly ok: true; readonly datos: T } | { readonly ok: false; readonly status: number; readonly mensaje: string | null };

/** Mismo patrón que `pedirEstudios`: el token lo captura la pantalla. El mensaje de error de la API se devuelve para enseñarlo. */
export async function pedirPurgas<T>(token: string, ruta: string, method = 'GET', body?: object): Promise<ResultadoPurgas<T>> {
  try {
    const r = await fetch(`${BASE}/purgas${ruta}`, {
      method,
      headers: { authorization: `Bearer ${token}`, ...(body ? { 'content-type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!r.ok) {
      const cuerpo = (await r.json().catch(() => null)) as { error?: { mensaje?: string } } | null;
      return { ok: false, status: r.status, mensaje: cuerpo?.error?.mensaje ?? null };
    }
    return { ok: true, datos: (await r.json()) as T };
  } catch {
    return { ok: false, status: 0, mensaje: null };
  }
}
